'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'envelope';
var width = 512;
var height = 512;
var aliases = [128386,9993,61443];
var unicode = 'f0e0';
var svgPathData = 'M16 64l-16 0 0 384 512 0 0-384-496 0zm464 56l0 15.9-224 164.3-224-164.3 0-39.9 448 0 0 24zm0 55.6l0 240.4-448 0 0-240.4 214.5 157.3 9.5 6.9 9.5-6.9 214.5-157.3z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faEnvelope = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;